import { Link } from 'react-router-dom'

export default function ToolCard({ id, name, description, icon: Icon, subdomain, color }) {
  return (
    <Link
      to={`/app/${id}`}
      className="group relative neu-panel p-8 transition-all duration-300 hover:scale-[1.02] hover:shadow-glossy overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl pointer-events-none z-10"></div>
      
      <div
        className="relative z-20 w-14 h-14 neu-panel-inset rounded-xl flex items-center justify-center mb-6 overflow-hidden border border-black/50"
      >
        <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent pointer-events-none"></div>
        <Icon size={26} style={{ color }} className="drop-shadow-[0_0_8px_rgba(255,255,255,0.2)]" />
      </div>

      <h3 className="relative z-20 text-xl font-display font-bold text-white mb-3 tracking-tight drop-shadow-md">
        {name}
      </h3>

      <p className="relative z-20 text-hs-text text-sm mb-6 leading-relaxed">
        {description}
      </p>

      <div className="relative z-20 flex items-center">
        <span className="inline-flex items-center px-4 py-1.5 rounded-full shadow-neu-in-deep bg-black/40 text-[10px] font-mono font-bold text-white/70 uppercase tracking-widest border border-white/5">
          {subdomain}
        </span>
      </div>
      
      {/* Dynamic Hover Glow */}
       <div 
        className="absolute -inset-10 opacity-0 group-hover:opacity-20 transition-opacity pointer-events-none duration-700 blur-3xl z-0"
        style={{ background: `radial-gradient(circle at center, ${color} 0%, transparent 60%)` }}
       />
    </Link>
  )
}
